import React, { useEffect, useContext, useState } from 'react';
import classNames from 'classnames';
import { getPendantColor } from '../../utils/color';
import { getPageSameType, toTop } from '../../utils/util';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import intl from 'react-intl-universal';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';

interface ILangButton {
  rootStore?: RootStore;
}

const LangButton = (props: ILangButton) => {
  const { localeStore } = props.rootStore!;

  const loc = intl.getInitOptions().currentLocale;
  const isChinese = loc === 'zh-CN';

  const changeLang = () => {
    localeStore.setLocale(loc === 'zh-CN' ? 'en-US' : 'zh-CN');
    stat.event('button_locale');
  };

  return (
    <NormalButton onClick={changeLang} style={{ fontSize: 14 }}>
      {isChinese ? 'En' : '中'}
    </NormalButton>
  );
};

export default LangButton;
